<div>
  <p-toast/>
    <div class="my-3">
        Favor de introducir la nueva contraseña para tener acceso a su cuenta.
    </div>
    <div>
        <form [formGroup]="password">
            <div class="d-flex flex-column gap-3 mb-3">
              <label for="password" class="font-semibold w-6rem">Nueva Contraseña: </label>
              <p-password weakLabel="Simple" mediumLabel="Medio" strongLabel="Fuerte" [toggleMask]="true"
                formControlName="password" (onBlur)="setPass($event)">
              </p-password>
              <ul class="pl-2 mt-2" style=" font-size: 12px;">
                <li [ngClass]="{'haveLower':haveLower}">Al menos una Mayúscula</li>
                <li [ngClass]="{'haveUpper':haveUpper}">Al menos una minúscula</li>
                <li [ngClass]="{'haveNumber':haveNumber}">Al menos un número</li>
                <li [ngClass]="{'haveLength':haveLength}">Mínimo 8 caracteres</li>
              </ul>
            </div>
            <div class="flex align-items-center gap-3 mb-3">
              <label for="username" class="font-semibold w-6rem">Confirmar Contraseña: </label>
              <input style="width: 70%" type="password" id="passwordConfirm" name="passwordConfirm" class="form-control" (blur)="setPassword()"
                formControlName="passwordConfirm" required>
            </div>
            <div class="d-flex btn-container gap-2">
              <p-button label="Enviar" class="mr-3 me-auto"
                [disabled]="infoRegister.password?.invalid || !isValidPassword"
                (click)="updatePassword()" />
              <p-button label="Cancelar" severity="secondary" (click)="setPass($event)" />
            </div>
          </form>
    </div>
</div>